// AddSequencetask — modal-embedded form to attach a Task to a Process (Sequence).
// Refactored 2026-05-05 (Phase 3.2, Class P) onto ModalFormHeader.

import React, { useEffect, useState } from "react";
import {
  Button, Select, MenuItem, FormControl, Stack, Box,
} from "@mui/material";
import { LinkRounded } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { showErrorToast, showSuccessToast } from "../../utils/Toast";
import ApiCall from "../../utils/apicall";
import { createSequencetask } from "../../feature/sequenceSlice";
import { ModalFormHeader, FieldLabel } from "../PaperForm";

const AddSequencetask = (props) => {
  const dispatch = useDispatch();
  const [taskid, settaskid] = useState("");
  const [task, settask] = useState([]);
  const [, setError] = useState(null);

  useEffect(() => {
    const getTask = async () => {
      try {
        const res = await ApiCall.get(
          `/sequencestask/indenpendent-task/${props.data.jobid}`
        );
        settask(res.data.data);
      } catch (err) {
        setError("Error fetching tasks. Please try again.");
      }
    };
    getTask();
  }, [props.data.jobid]);

  const handleSubmit = () => {
    if (!taskid) { showErrorToast("Please select a Task"); return; }
    const sequencetaskData = {
      sequence_id: props.data.id,
      task_id: taskid,
    };
    dispatch(createSequencetask(sequencetaskData)).then((res) => {
      if (res.type === "createSequencetask/SequenceTask/fulfilled") {
        const { message } = res.payload;
        showSuccessToast(message);
        props.setOpen(false);
      }
      if (res.type === "createSequencetask/SequenceTask/rejected") {
        showErrorToast("Process Task not created! Something went wrong.");
      }
    });
  };

  const handleJobSelection = (event) => { settaskid(event.target.value); };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Process Task"
        title="Add Process Task"
        icon={LinkRounded}
      />
      <Stack spacing={2}>
        <Box>
          <FieldLabel required hint="independent tasks not yet attached to a process">
            Task
          </FieldLabel>
          <FormControl fullWidth size="small">
            <Select
              value={taskid}
              onChange={handleJobSelection}
              displayEmpty
              variant="outlined"
              sx={{ textAlign: "left" }}
            >
              <MenuItem value=""><em>Select a task…</em></MenuItem>
              {task.length === 0 && (
                <MenuItem disabled value="none">No independent tasks found</MenuItem>
              )}
              {task.map((dataItem) => (
                <MenuItem key={dataItem.id} value={dataItem.id}>{dataItem.pmkNumber}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: "100%",
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: "0.01em",
          }}
        >
          {props.isLoading ? "Loading…" : "Attach Task"}
        </Button>
      </Stack>
    </Box>
  );
};

export default AddSequencetask;
